export const FEE_PERCENT_TO_COMPOUND_DEFAULT = 10;
export const FEE_PERCENT_TO_COMPOUND_MIN = 5;
export const FEE_PERCENT_TO_COMPOUND_MAX = 100;
